export enum ProgramProviderStatus {
    ACTIVATED = 'ACTIVATED',
    INACTIVATED = 'INACTIVATED',
    REMOVED = 'REMOVED'
}